document.addEventListener('DOMContentLoaded', function () {
  const headers = document.querySelectorAll('[data-drye-header]');

  headers.forEach(function (header) {
    const overlay = header.querySelector('[data-drye-header-overlay]');
    const openBtn = header.querySelector('[data-drye-header-open]');
    const closeBtn = header.querySelector('[data-drye-header-close]');
    const navItems = header.querySelectorAll('[data-drye-header-nav-item]');

    if (!overlay || !openBtn || !closeBtn) return;

    let lastFocusedElement = null;

    function openMenu() {
      lastFocusedElement = document.activeElement;
      overlay.hidden = false;

      requestAnimationFrame(function () {
        overlay.classList.add('is-open');
        overlay.removeAttribute('hidden');
        openBtn.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      });
    }

    function closeMenu() {
      overlay.classList.remove('is-open');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';

      window.setTimeout(function () {
        overlay.setAttribute('hidden', 'hidden');

        if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
          lastFocusedElement.focus();
        }
      }, 380);
    }

    openBtn.addEventListener('click', openMenu);
    closeBtn.addEventListener('click', closeMenu);

    navItems.forEach(function (item) {
      item.addEventListener('click', closeMenu);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && overlay.classList.contains('is-open')) {
        closeMenu();
      }
    });
  });
});